(ns teamoesterreich.admin-mode.event.detail.member-selector.filter-boolean
  (:require
    [clojure.string]
    [reagent.core :as r]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.save :refer [save]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    ))





(defn edit-filter-popup [opt !edit-item-popup !filter-item]
  [mui/modal
   {:aria-labelledby  "simple-modal-title"
    :aria-describedby "simple-modal-description"
    :style            {:display        "flex"
                       :marginRight    "auto"
                       :marginLeft     "auto"
                       :alignItems     "center"
                       :justifyContent "center"}
    :open             (not (nil? @!edit-item-popup))
    }
   [:div
    {
     :class "modal"
     :style {:width 600}}
    [:h2 "Filter bearbeiten " (:name opt)]

    ;[:pre (pr-str @!filter-item)]

    [mui/form-control-label
     {:style     {:paddingLeft "16px" :paddingRight "16px"}
      :label     "Nein / Ja"
      :fullWidth true
      :control   (r/as-element [mui/switch {:variant  "contained"
                                            :checked  (or (:val @!filter-item) false)
                                            :onChange (fn [e b]
                                                        (println "set-val" (if b true false))
                                                        (reset! !filter-item (merge @!filter-item {:val (if b true false)
                                                                                                   :short ((:short opt) b)})))
                                            }])}
     ]

    [:br]

    [mui/button
     {:variant   "contained"
      :startIcon (r/as-element [keyboard-arrow-left])
      :style     {:marginRight 50}
      :onClick   #(reset! !edit-item-popup nil)
      }
     "Schließen"]

    ]]
  )



